<template>
  <section>
    <div class="settings-header m-0">
      {{ __('Configurações de agendamento') }}
    </div>
    <p class="form-text m-0 subtitle">
        {{ __('Defina aqui seu horário de atendimento.') }}
    </p>
    <div class="row">
      <div class="col-12">
        <div class="form-group m-0">
          <label class="header header-weekDays">{{ __('Dias da semana') }}</label>
          <div class="d-flex">
            <div class="salesflow-square-purple-checkbox">
              <input type="checkbox" class="form-check-input" id="monday" v-model="settings.weekDays.monday">
              <label class="form-check-label" for="monday">{{ __('Segunda') }}</label>
            </div>
            <div class="salesflow-square-purple-checkbox">
              <input type="checkbox" class="form-check-input" id="tuesday" v-model="settings.weekDays.tuesday">
              <label class="form-check-label" for="tuesday">{{ __('Terça') }}</label>
            </div>
            <div class="salesflow-square-purple-checkbox">
              <input type="checkbox" class="form-check-input" id="wednesday" v-model="settings.weekDays.wednesday">
              <label class="form-check-label" for="wednesday">{{ __('Quarta') }}</label>
            </div>
            <div class="salesflow-square-purple-checkbox">
              <input type="checkbox" class="form-check-input" id="thursday" v-model="settings.weekDays.thursday">
              <label class="form-check-label" for="thursday">{{ __('Quinta') }}</label>
            </div>
            <div class="salesflow-square-purple-checkbox">
              <input type="checkbox" class="form-check-input" id="friday" v-model="settings.weekDays.friday">
              <label class="form-check-label" for="friday">{{ __('Sexta') }}</label>
            </div>
            <div class="salesflow-square-purple-checkbox">
              <input type="checkbox" class="form-check-input" id="saturday" v-model="settings.weekDays.saturday">
              <label class="form-check-label" for="saturday">{{ __('Sábado') }}</label>
            </div>
            <div class="salesflow-square-purple-checkbox">
              <input type="checkbox" class="form-check-input" id="sunday" v-model="settings.weekDays.sunday">
              <label class="form-check-label" for="sunday">{{ __('Domingo') }}</label>
            </div>
          </div>

          <label class="header">{{ __('Horário de atendimento') }}</label>
          <div class="time-slots-container" v-if="isDataLoaded">
            <div 
              v-for="(hours, index) in settings.openingHours" 
              :key="hours.slotId"
              class="time-slot-wrapper"
              :style="{ marginBottom: index !== settings.openingHours.length - 1 ? '16px' : '0' }"
            >
              <div class="d-flex align-items-center">
                <label class="form-check-label margin-right-8">{{ __('Ínicio') }}</label>
                <InputDateTimepicker
                  type="time"
                  input-class="form-control time"
                  popup-class="time-picker-popup"
                  :time-picker-options="{
                    start: '00:00',
                    step: '00:15',
                    end: '23:45',
                  }"
                  :value="hours.start"
                  @input="val => updateTime(index, 'start', val)"
                  :is-schedule="true"
                />
                <label class="form-check-label margin-end">{{ __('Fim') }}</label>
                <InputDateTimepicker
                  type="time"
                  input-class="form-control time"
                  :value="hours.end"
                  @input="val => updateTime(index, 'end', val)"
                  :is-schedule="true"
                />
                <a v-if="index === 0" 
                   href="javascript:void(0)" 
                   @click="addTimeSlot" 
                   class="add-time-link">
                  <img src="/build/icons/button-add-time.svg" alt="Add time" class="add-time-icon" />
                </a>
                <a v-else
                   href="javascript:void(0)" 
                   @click="removeTimeSlot(hours.slotId)" 
                   class="remove-time-link">
                  <img src="/build/icons/button-remove-time.svg" class="remove-time-icon" />
                </a>
              </div>
            </div>
          </div>

          <!-- label class="header">{{ __('Duração do atendimento') }}</label>
          <div>
            <select class="form-control select-border" placeholder="Selecione" v-model="settings.duration">
              <option value="" hidden>{{ __('Selecione') }}</option>
              <!-- TODO: Adicionar as opções de duração do atendimento ficará para outra milestone -->
            </select>
          </div -->

          <label class="header header-permissions">{{ __('Permissões') }}</label>
          <div>
            <div class="salesflow-square-purple-checkbox permissions mb-3">
              <input type="checkbox" class="form-check-input" id="allow-outside-hours" v-model="settings.allowOutsideHours">
              <label class="form-check-label" for="allow-outside-hours">{{ __('Permitir compromissos fora do horário') }}</label>
            </div>
            <div class="salesflow-square-purple-checkbox permissions">
              <input type="checkbox" class="form-check-input" id="allow-overlap" v-model="settings.allowOverlap">
              <label class="form-check-label" for="allow-overlap">{{ __('Permitir sobreposição de agendamentos') }}</label>
            </div>
          </div>
          <div>
            <button 
              type="submit" 
              class="salesflow-btn salesflow-btn-secondary button-margin"
              @click="saveSettings"
            >
              {{ __('Salvar') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Schedule',
  data() {
    return {
      isDataLoaded: false,
      settings: {
        weekDays: {
          monday: true,
          tuesday: true,
          wednesday: true,
          thursday: true,
          friday: true,
          saturday: false,
          sunday: false
        },
        openingHours: [{
          slotId: 1,
          start: '07:00',
          end: '20:00'
        }],
        duration: '15',
        allowOutsideHours: true,
        allowOverlap: true
      },
      configId: null
    }
  },
  computed: {
    timeSlots: {
      get() {
        return this.settings.openingHours;
      },
      set(value) {
        this.$set(this.settings, 'openingHours', value);
      }
    }
  },
  methods: {
    getScheduleConfigurations() {
      this.isDataLoaded = false;
      this.$http.get('/user/schedule/settings')
        .then((response) => {
          let config;
          try {

            if (!response.data.settings) {
              this.isDataLoaded = true;
              return;
            }
            
            this.configId = response.data.settings ? response.data.settings.id : null;
            const settingData = response.data.settings.setting;

            if (typeof settingData === 'string') {
              try {
                config = JSON.parse(settingData);
              } catch {
                const cleanString = settingData
                  .replace(/\\\"/g, '"')
                  .replace(/\\/g, '')
                  .replace(/^"(.*)"$/, '$1');
                
                config = JSON.parse(cleanString);
              }
            } else {
              config = parameterData;
            }
            
            if (config && typeof config === 'object') {
              let openingHours = [];
              if (Array.isArray(config.openingHours)) {
                openingHours = config.openingHours.map((hour, index) => ({
                  slotId: index + 1,
                  start: this.formatTime(hour.start) || '07:00',
                  end: this.formatTime(hour.end) || '20:00'
                }));
              } else if (config.openingHours) {
                openingHours = [{
                  slotId: 1,
                  start: this.formatTime(config.openingHours.start) || '07:00',
                  end: this.formatTime(config.openingHours.end) || '20:00'
                }];
              }
              
              this.$set(this.settings, 'openingHours', openingHours);
              this.$set(this.settings, 'weekDays', config.weekDays || this.settings.weekDays);
              this.$set(this.settings, 'duration', config.duration || this.settings.duration);
              this.$set(this.settings, 'allowOutsideHours', config.allowOutsideHours || false);
              this.$set(this.settings, 'allowOverlap', config.allowOverlap || false);
              
              this.$nextTick(() => {
                this.isDataLoaded = true;
              });
            }
          } catch (error) {
            Alert.error(this.__('Erro ao processar os dados'));
            this.isDataLoaded = true;
          }
        }).catch((error) => {
          Alert.error(this.__('Erro ao carregar as configurações'));
          this.isDataLoaded = true;
        });
    },

    formatTime(time) {
      if (!time) return null;
      const [hours, minutes] = time.split(':');
      return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    },

    saveSettings() {
      const settingsString = JSON.stringify(this.settings);
      const configId = this.configId;

      const endpoint = configId 
        ? `/user/schedule/settings/${configId}`
        : '/user/schedule/settings';
      
      const method = configId ? 'put' : 'post';

      this.$http[method](endpoint, { setting: settingsString })
        .then((response) => {
          if (response.data?.message) {
            Alert.success(response.data.message);
            if (!this.configId) {
              this.configId = response.data.id;
            }
          } else {
            Alert.error(response.data.message);
          }
        })
        .catch((error) => {
          Alert.error(error.response?.data?.message || this.__('Erro ao salvar as configurações'));
        });
    },

    addTimeSlot() {
      if (this.settings.openingHours.length >= 5) {
        Alert.info(this.__('Limite de 5 horários de atendimento atingido. Altere ou exclua um para adicionar outro.'));
        return;
      }
      const maxId = Math.max(...this.settings.openingHours.map(slot => slot.slotId), 0);
      this.settings.openingHours.push({
        slotId: maxId + 1,
        start: '07:00',
        end: '20:00'
      });
    },

    removeTimeSlot(slotId) {
      const index = this.settings.openingHours.findIndex(slot => slot.slotId === slotId);
      if (index !== -1) {
        this.settings.openingHours.splice(index, 1);
      }
    },

    updateTime(index, field, value) {
      const newTimeSlots = [...this.timeSlots];
      newTimeSlots[index] = {
        ...newTimeSlots[index],
        [field]: value
      };
      this.timeSlots = newTimeSlots;
    }
  },
  created() {
    this.getScheduleConfigurations();
  },
}
</script>

<style scoped>
  .subtitle {
    line-height: 18px;
  }
  .header {
    font-size: 16px !important;
    font-weight: 700 !important;
    margin-top: 32px;
    margin-bottom: 16px;
  }

  .header-permissions {
    margin-top: 28px !important;
  }

  .header-weekDays {
    margin-top: 41px !important;
  }

  .salesflow-square-purple-checkbox {
    display: flex;
    align-items: center;
    margin-right: 12px;
    
    input[type='radio'],
    input[type='checkbox'] {
      display: none;
    }

    label {
      cursor: pointer;
      margin-left: 8px;
      display: flex;
      align-items: center;
    }

    input[type='radio'] + label:before,
    input[type='checkbox'] + label:before {
      content: '\00a0';
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      border-radius: 4px;
      background: #FFFFFF;
      box-shadow: 0px 2px 5px 0px #676E7614, 0px 0px 0px 1px #676E7629, 0px 2px 5px 0px #676E7614;
      margin-right: 8px;
    }

    input[type='radio'] + label:hover:before,
    input[type='checkbox'] + label:hover:before {
      background: #FAFAFA;
      box-shadow: 0px 1px 1px 0px #8869FD1F, 0px 0px 0px 1px #5F33FFA3, 0px 2px 5px 0px #8869FD14;
    }

    input[type='radio']:checked + label:before,
    input[type='checkbox']:checked + label:before {
      text-align: center;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
      border-radius: 4px;
      background: #8869FD;    
      box-shadow: none;
      content: '\2714';
      color: #FFF;
      font-size: 13px;
    }

    input[type='radio']:checked + label:hover:before,
    input[type='checkbox']:checked + label:hover:before {
      background: #5F33FF;
      box-shadow: 0px 1px 1px 0px #0000001F, 0px 0px 0px 1px #676E763D, 0px 2px 5px 0px #676E7614;
    }

    input[type='radio']:checked + label:after,
    input[type='checkbox']:checked + label:after {
      font-weight: bold;
    }
  }

  .salesflow-square-purple-checkbox.permissions input[type='radio']:checked + label:before,
  .salesflow-square-purple-checkbox.permissions input[type='checkbox']:checked + label:before {
    padding-top: 2px;
  }

  .salesflow-square-purple-checkbox.permissions {
    padding-top: 2px;
  }

  .form-check-label {
    margin:0 !important;
  }

  .button-margin {
    margin-top: 56px;
  }

  .select-border {
    border-radius: 8px !important;
    padding: 9px 16px !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    color: #71767D !important;
    width: 208px;
    height: 44px;
  }

  .select-border:focus,
  .select-border.show {
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
    outline: 0 !important;
    border: 1px solid #D1D1D1 !important;
  }

  .margin-right-8 {
    margin-right: 8px !important;
  }

  .margin-end {
    padding: 0 12px 0 16px !important;
  }

  .mx-datepicker {
    margin-right: 0 !important;
  }

  .add-time-icon {
    display: inline-block;
    margin-left: 15px;
  }

  .add-time-link:hover .add-time-icon {
    content: url('/build/icons/button-add-time-hover.svg');
    margin-left: 8px;
  }

  .time-slots-container {
    display: flex;
    flex-direction: column;
  }

  .time-slot-wrapper {
    display: block;
    min-height: 44px;
  }

  .time-slot-wrapper:not(:last-child) {
    margin-bottom: 16px;
  }

  .remove-time-icon {
    display: none;
    margin-left: 8px;
  }

  .remove-time-link {
    width: 24px;
    height: 24px;
    margin-left: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .remove-time-link:hover .remove-time-icon {
    display: inline-block;
    content: url('/build/icons/button-remove-time.svg');
  }
</style>

